import * as marked from "marked";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Button, Form, Header, Icon, Message } from "semantic-ui-react";
import { SystemMessageStore } from "../../stores/system-message-store";


declare var toastr: any;

interface IProps {
	systemMessageStore?: SystemMessageStore;
}

interface IState {
}

@inject("systemMessageStore") @observer
export class SystemMessage extends React.Component<IProps, IState>{
	constructor(props, state) {
		super(props, state);

		this.handleDismiss = this.handleDismiss.bind(this);
	}

	handleDismiss() {
		this.props.systemMessageStore.dismissMessage();
	}

	render() {
		const style = {
			"position": "fixed",
			"left": "50%",
			"max-width": "80%",
			"min-width": "300px",
			"z-index": "30",
			"top": "-2px",
			"transform": "translate(-50%, 0)",
			"color": "black",
			"font-weight": "bold"
		};
		if (!this.props.systemMessageStore || this.props.systemMessageStore.activeMessage == null) {
			return null;
		}
		else {
			return (
				<Message size="mini" color="orange" style={style} onDismiss={this.handleDismiss} className="system-message">
					<p dangerouslySetInnerHTML={{ "__html": marked(this.props.systemMessageStore.activeMessage.text, { "sanitize": true }) }} />
				</Message>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/common/system-message.tsx